import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Hochwertiges Equipment",
      subtitle: "Dein perfekter Start",
      icon: "💻",
      description: "Egal, ob du Anfänger bist oder deine Ausstattung upgraden möchtest – wir stellen dir alles, was du brauchst:",
      features: [
        "Laptop & Kamera: Hochwertige Geräte für gestochen scharfe Streams.",
        "Lichtausstattung: Perfekte Beleuchtung für deinen Auftritt.",
        "Lovense Starterpaket: Die beste Technologie für Interaktion mit deinen Fans."
      ]
    },
    {
      id: 2,
      title: "Studio-Wohnnetzwerk",
      subtitle: "Dein Raum für Kreativität",
      icon: "🏠",
      description: "Manchmal ist es schwer, zu Hause zu arbeiten – deshalb bieten wir dir Zugang zu unseren Studio-Wohnungen in ganz Deutschland.",
      features: [
        "Voll ausgestattete Apartments: Alles, was du für professionelles Streaming brauchst – inklusive Multi-Streaming-Setup.",
        "Flexibel nutzbar: Ob langfristig oder für spontane Sessions."
      ]
    },
    {
      id: 3,
      title: "Persönliche Betreuung",
      subtitle: "Wir sind für dich da",
      icon: "👥",
      description: "Unser Team unterstützt dich in allen Bereichen:",
      features: [
        "Content-Produktion: Tipps und Tricks, wie du ansprechende Inhalte erstellst.",
        "Plattform-Beratung: Strip-Chat, myDirtyHobby oder andere Plattformen – wir zeigen dir, wie du überall erfolgreich bist.",
        "Outfit-Beratung: Nach der Probezeit bekommst du drei kostenlose Outfits, damit du perfekt gestylt starten kannst."
      ]
    },
    {
      id: 4,
      title: "Zugang zu exklusiven Vorteilen",
      subtitle: "Profitiere von unserem Netzwerk",
      icon: "💎",
      description: "Als Teil unseres Netzwerks profitierst du von unschlagbaren Preisen und Top-Qualität:",
      features: [
        "Erotik-Toys & Dessous: Zu den Einkaufspreisen, die wir als Agentur bekommen.",
        "Zusätzliche Tools: Alles, was du für deinen Erfolg brauchst, direkt von unseren Partnern."
      ]
    },
    {
      id: 5,
      title: "Dein Erfolg ist unser Ziel",
      subtitle: "Gemeinsam zum Erfolg",
      icon: "🚀",
      description: "Mit unserem umfangreichen Netzwerk an Plattformen und Partnern helfen wir dir, das Beste aus deiner Karriere herauszuholen. Von der ersten Anmeldung bis zum Aufbau deiner eigenen Marke – wir sind an deiner Seite."
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
        <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6">
              Unsere <span className="text-gradient">Leistungen</span>
            </h1>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-playfair mb-8">
              Where <span className="text-hot-pink">Temptation</span> Meets <span className="text-accent-purple">Talent</span>
            </h2>
            <p className="text-lg sm:text-xl text-white/80 mb-8">
              Wir bieten dir ein Rundum-sorglos-Paket, damit du dich ganz auf deinen Erfolg konzentrieren kannst. 
              Mit Angel & Devil Network hast du einen Partner, der dich in jeder Phase deiner Karriere begleitet – 
              vom ersten Stream bis zum Aufbau deiner Marke.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20">
        <div className="container-custom">
          <div className="space-y-24">
            {services.map((service) => (
              <div key={service.id} className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                <div className="relative glass-effect rounded-2xl p-8 sm:p-12">
                  <div className="flex flex-col md:flex-row gap-8">
                    <div className="md:w-1/3">
                      <div className="text-4xl sm:text-5xl mb-4">{service.icon}</div>
                      <h3 className="text-2xl sm:text-3xl font-playfair text-gradient mb-2">{service.title}</h3>
                      <p className="text-xl text-white/90">{service.subtitle}</p>
                    </div>
                    <div className="md:w-2/3">
                      <p className="text-lg text-white/80 mb-6">{service.description}</p>
                      {service.features && (
                        <ul className="space-y-4">
                          {service.features.map((feature, index) => (
                            <li key={index} className="flex items-start gap-3">
                              <span className="text-hot-pink">✦</span>
                              <span className="text-white/80">{feature}</span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-b from-deep-black to-deep-black/95">
        <div className="container-custom">
          <div className="relative max-w-4xl mx-auto">
            <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
            <div className="relative glass-effect rounded-2xl p-8 sm:p-12 text-center">
              <h2 className="text-2xl sm:text-3xl font-playfair text-gradient mb-6">
                Bereit für den nächsten Schritt?
              </h2>
              <p className="text-lg sm:text-xl text-white/80 mb-8">
                Nutze unsere professionelle Ausstattung und starte deine Karriere!
              </p>
              <Link to="/bewerbung" className="btn-primary">
                JETZT DURCHSTARTEN
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
